export default {
  apiURL: '/api/v2/'
};



// WEBPACK FOOTER //
// ./src/config/production.js